export default {
    // to standardize all display dates
    methods: {
        dateFormat(date) {
            return moment(date)
                .format('DD MMM YYYY HH:mm:ss')
                .toUpperCase();
        },

        dateOnly(date) {
            return moment(date)
                .format('DD MMM YYYY')
                .toUpperCase();
        },

        timeOnly(date) {
            return moment(date)
                .format('HH:mm:ss')
                .toUpperCase();
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/date-format.js